// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".netto-top-bar[data-v-1657d36b]{align-items:center;background-color:#000;display:flex;font-size:14px;justify-content:flex-end}.netto-top-bar a[data-v-1657d36b]{color:#fff}.netto-top-bar .separator[data-v-1657d36b]{background-color:#fff;height:1rem;margin-left:1rem;margin-right:1rem;width:1px}.netto-top-bar .dc-image[data-v-1657d36b]{background-color:#56246f}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
